<template>
  <div class="row cursor-pointer my-2">
    <div class="col-10" @click="view">
      <div>
        <strong>{{ message.name }}</strong>
      </div>
    </div>

    <div class="col-2">
      <button aria-label="Oznacz jako przeczytane" class="btn btn-icon mr-2" @click="markAsRead">
        <i class="fal fa-fw fa-times" />
      </button>
    </div>
  </div>
</template>

<script>
// @vuese
// Powiadomienie
// @group messages
export default {
  props: {
    // Powiadomienie
    message: {
      type: Object,
      required: true
    }
  },
  methods: {
    // @vuese
    // Pokaż powiadomienie
    view() {
      this.$emit('view', this.message.id);
    },
    // @vuese
    // Oznacz jako przeczytaną
    markAsRead() {
      this.$emit('read', this.message.id);
    }
  }
};
</script>
